import apiClient from './apiClient';
import type { PaginatedResponse } from '../types/api';

export interface DoctorAssistantAssignment {
  id: number;
  doctor_id: number;
  assistant_user_id: number;
  granted_at: string;
  revoked_at: string | null;
  can_sign: boolean;
  assistant_user?: { id: number; name: string; lastname?: string };
}

/**
 * Admin-only doctor <-> assistant assignment CRUD (clinical-delegation R2,
 * R4, R5). `check.profile:doctor-assistants` maps to the `admin` module —
 * only used from admin screens (DoctorDetailPage's "Asistentes" tab, task
 * 3.9). Grant/revoke are not exposed yet here; this is list-only.
 */
export const doctorAssistantService = {
  async listByDoctor(doctorId: number): Promise<DoctorAssistantAssignment[]> {
    const response = await apiClient.get<PaginatedResponse<DoctorAssistantAssignment>>(
      `/doctor-assistants?doctor_id=${doctorId}&active_only=true`,
    );
    return response.data.data || [];
  },
};

export default doctorAssistantService;
